import { Card } from "@/src/components/cards";
import { ListConstructor } from "@/src/components/fetchableLists";
import { Patient, PatientLight } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useQuery } from "@tanstack/react-query";
import { PatientsListItem } from "./patientsListItem";

export function PatientDetector({
  firstName,
  lastName,
  birth,
  nin,
  onSelect,
}: {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  birth: string | null | undefined;
  nin: string | null | undefined;
  onSelect: (patient: Patient) => void;
}) {
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["PatientDetector", firstName, lastName, birth, nin],
    queryFn: async () => {
      if ((firstName && lastName && birth) || nin) {
        return await apiFetch(
          "patients",
          "detectPatients",
          {
            firstName,
            lastName,
            birth,
            nin,
          },
          "Erreur lors du chargement des antécédents"
        );
      }
      return null;
    },
  });

  if (!data) return null;
  if (!data?.length) return null;

  return (
    <ListConstructor isLoading={false} isError={false} data={data}>
      <div className="c1 gap10">
        <div className="bold">Patient(s) déjà existant(s)</div>
        {data?.map((patient) => {
          return (
            <PatientsListItem
              key={patient.id}
              patient={patient}
              selectedPatient={null}
              onSelect={(patient) => {
                onSelect(patient);
              }}
              searchKey=""
            ></PatientsListItem>
          );
        })}
      </div>
    </ListConstructor>
  );
}

export default PatientDetector;
